import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateMaintenanceRequestDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/maintenance-record/create-maintenance-request-dto';
import { MaintenanceRecordDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/maintenance-record/maintenance-record-dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CreateMaintenanceRecordService {

  constructor(private httpClient: HttpClient) { }

  createMaintenance(maintenance: CreateMaintenanceRequestDto) {
    return this.httpClient.post<MaintenanceRecordDto>(`${environment.apiServer}/Adjuster/Claim/CreateMaintenanceRecord`, maintenance);
  }
}
